import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: ", ";\n  padding-top: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: 56.25%; /* for 16:9 ratio */\n  position: relative;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  box-sizing: border-box;\n  display: block;\n  height: 100%;\n  padding: ", ";\n  transition: background-color ", ", color ", ";\n\n  &:hover {\n    background-color: ", ";\n\n    ", " {\n      opacity: 1;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-right: ", ";\n  opacity: 0;\n  transition: opacity ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { ellipsis } from 'polished';
import { formatDate } from '@scp/ui-shared/core/utils';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { Spacing } from '@scp/ui-shared/components/layout';
import { Icon } from '@scp/ui-shared/theme/icons';
import { LinkOrButton } from '@scp/ui-shared/components/buttons';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { color, property } from '@scp/ui-shared/theme/variables';
import { PillIndicator } from '@scp/ui-shared/components';
import { Paragraph, Subtext } from '@scp/ui-shared/components/typography';
import { baselineToRem, rem } from '@scp/ui-shared/theme/utils';
var E2E_SUFFIX = '-card';
var HoverIcon = styled(Icon).attrs({
  color: color.icon,
  name: 'launch',
  size: baselineToRem(5)
})(_templateObject(), baselineToRem(1), property.transition);
var MediaLink = styled(LinkOrButton).attrs({
  target: '_blank',
  rel: 'noopener'
})(_templateObject2(), rem('1px'), baselineToRem(2), property.transition, property.transition, color.backgroundSecondary, HoverIcon);
var MediaWithRipple = withRippleEffect(MediaLink);
var ImageWrapper = styled.div(_templateObject3());
var Image = styled.img(_templateObject4(), rem("".concat(property.borderRadius, "px")));
var BasedImgWrapper = styled(Image).attrs({
  as: 'div'
})(_templateObject5(), color.imgBackground);
var DataPart = styled.div(_templateObject6());
var AdditionalData = styled.div(_templateObject7(), baselineToRem(2), baselineToRem(5));
var Topic = styled(PillIndicator).attrs({
  type: 'small',
  color: 'light-blue'
})(_templateObject8(), baselineToRem(2));
var Title = styled(Paragraph).attrs({
  as: 'h2'
})(_templateObject9(), ellipsis(null, 3));
export var ArticleCard = function ArticleCard(_ref) {
  var title = _ref.title,
      url = _ref.url,
      createdAt = _ref.createdAt,
      topics = _ref.topics,
      imageUrl = _ref.imageUrl,
      onClick = _ref.onClick;
  return React.createElement(MediaWithRipple, {
    href: url,
    dataE2e: getE2eLabel(title, E2E_SUFFIX),
    onClick: onClick
  }, React.createElement("article", null, React.createElement(ImageWrapper, null, imageUrl ? React.createElement(Image, {
    src: imageUrl
  }) : React.createElement(BasedImgWrapper, null, React.createElement(Icon, {
    name: "scp-health-logo-white-text",
    size: "25%"
  }))), React.createElement(AdditionalData, null, React.createElement(DataPart, null, React.createElement(Spacing, {
    marginRight: 2
  }, React.createElement(Subtext, {
    noMargin: true
  }, formatDate(createdAt, {
    format: 'longCommaYear'
  }))), topics && topics.map(function (topic) {
    return React.createElement(Topic, {
      key: topic
    }, topic);
  })), url && React.createElement(HoverIcon, null)), React.createElement(Title, {
    noMargin: true,
    bold: true
  }, title)));
};